import React, {useState, useEffect}  from 'react';
import star from '../images/star.svg';
import whitearrow from '../images/white_arrow.svg';
function NFTGridCoachSelectable({nftArray, nftType, maxSel, setSelectedItems, selectedItems}){

const nt = nftType.toLowerCase();
const [nftArr, setNFTArr] = useState(nftArray);
const [selItems, setSelItems] = useState([]);
const [selectedSort, setSelectedSort] =  useState("");


useEffect(()=>{
    let tempSelected = [];
    if (selectedItems > 0){
    for (let x = 0; x < nftArray.length; x++){
        if (nftArray[x] !== undefined && Object.keys(nftArray[x]).length > 0 && parseInt(nftArray[x].id) === parseInt(selectedItems))
    {
        tempSelected.push(nftArray[x].id);
    }
        
    }
    }
    setSelItems(tempSelected);
    setNFTArr(nftArray);
    
},[nftArray, selectedItems])



const showDetails = (nt,i) => {
    let curstatus = document.getElementById(nt+'card'+i).name;

    if (curstatus === 'close' || curstatus === undefined) {
        document.getElementById(nt+'details'+i).style.display = 'block';
        document.getElementById(nt+'card'+i).style.maxWidth = '400px';
        document.getElementById(nt+'card'+i).style.minWidth = '400px';
        document.getElementById(nt+'cardrow'+i).style.maxWidth = '400px';
        document.getElementById(nt+'cardrow'+i).style.marginRight = '30px';
        document.getElementById(nt+'card'+i).name = 'open';
        document.getElementById(nt+'img'+i).style.rotate = '-90deg';
    }else{
        document.getElementById(nt+'details'+i).style.display = 'none';
        document.getElementById(nt+'card'+i).style.maxWidth = '200px';
        document.getElementById(nt+'card'+i).style.minWidth = '205px';
        document.getElementById(nt+'cardrow'+i).style.maxWidth = '200px';
        document.getElementById(nt+'cardrow'+i).style.marginRight = 'calc(-0.5 * var(--bs-gutter-x));';
        document.getElementById(nt+'card'+i).name = 'close';
        document.getElementById(nt+'img'+i).style.rotate = '90deg';
    }
    
}


const selectCoach = (id) => {
    
    let tempSelected = [...selItems];
    if (tempSelected.includes(id)){
        tempSelected.splice(tempSelected.indexOf(id),1);
        setSelectedItems({});
    }else{
      //  if (tempSelected.length < maxSel){
            tempSelected = [];
            tempSelected.push(id);
            let tempcoach = nftArr.filter(x => x.id === id);
            setSelectedItems(tempcoach[0]);
      //  }
    }
    setSelItems(tempSelected);
}

const sortCoaches = () => {
    //let searchid = document.getElementById('filterbyid').value;
    let currentsort = document.getElementById('sortcoachoptions').value;
    console.log(currentsort);
    setSelectedSort(currentsort);
    //setFilterID(searchid);
    let racerstemp = [...nftArr];
    console.log(racerstemp);

    if (currentsort === 'rpasc'){
        racerstemp.sort(function(a, b){return a.reefpoints - b.reefpoints});
    }else if (currentsort === 'rpdesc'){
        racerstemp.sort(function(a, b){return b.reefpoints - a.reefpoints});
    }else if (currentsort === 'rankasc'){
        racerstemp.sort(function(a, b){return a.ranknumber - b.ranknumber});
    }else if (currentsort === 'rankdesc'){
        racerstemp.sort(function(a, b){return b.ranknumber - a.ranknumber});
    }else{
        racerstemp.sort(function(a, b){return a.id - b.id});
    }
    setNFTArr(racerstemp);
} 

    return <><div className='row createFormatRaceTypes col-md-12'><div className='col-md-12' style={{paddingRight:'50px', paddingTop:'10px', paddingBottom:'10px', backgroundColor: 'rgba(0, 0, 0, 0.2)', width:'100%', textAlign:'right'}}>Sort By: <select onChange={() => sortCoaches()} value={selectedSort} id="sortcoachoptions" ><option value="id">Coach ID</option><option value="rpasc">RPs lo to hi</option><option value="rpdesc">RPs hi to lo</option><option value="rankasc">Prestige lo to hi</option><option value="rankdesc">Prestige hi to lo</option></select></div></div><div className="row row-cols-1 row-cols-md-4 g-2" style={{marginTop:'20px', marginLeft:'40px', marginBottom:'20px'}}>
    {nftArr.map(function (card, i) {
        return <div className="col" key={i} id={nt+ 'card' + i.toString()} style={{minWidth:'180px'}} name={'close'}>
           
            <div className="card h-100 row" id={nt+ 'cardrow' + i.toString()} style={{maxWidth:'180px', flexDirection:'unset', cursor:'pointer', backgroundColor:(selItems.includes(card.id) ? 'gold' : '#ccc')}} >
            <div className="col" style={{paddingTop:'10px', paddingBottom:'5px'}}>
            <div className="image-box" style={{maxWidth:'152px'}} >
                    <img src={card.image} className="card-img-top" loading="lazy" alt={card.image} />
                    <div style={{position:'absolute', right:'0px', top:'180px', width:'20px', height:'94px',cursor:'pointer', backgroundColor:'#0d6efd', paddingTop:'36px'}} onClick={()=>showDetails(nt, i.toString())}> <img src={whitearrow} alt={whitearrow} id={nt+ 'img' + i.toString()} style={{rotate:'90deg', width:'80%'}}/></div>
            </div>
                <div className="card-body" style={{padding:'0px'}} onClick={() => selectCoach(card.id)}>
                    <div className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'left',maxWidth:'152px',fontSize:'1.1em'}}>{card.collection} #{card.id} </div>
                    <div style={{textAlign:'left', maxWidth:'152px', fontStyle:'italic',fontSize:'.9em'}}>{card.label}</div>
                    <p style={{textAlign:'left', maxWidth:'152px', paddingTop:'10px',paddingBottom:'10px', height:'30px'}}>{(card.levelarr !== undefined ? card.levelarr.map(function(lvl, x){return <img src={star} alt="ranks" style={{width:'30px'}} key={x} />}) : "")}</p>
                    <div style={{textAlign:'left',maxWidth:'152px'}}><span style={{color:'black',fontSize:'.9em'}}>Reef Points: {card.reefpoints}</span></div>
                </div>
            </div>
            <div className="col" id={nt+'details'+i.toString()} style={{display:'none'}}>
            <div style={{maxWidth:'300px',color:'black'}}>
                <p style={{fontSize:'.8em', marginTop:'10px'}}><span style={{fontWeight:'bold'}}>Class:</span> {card.rank} </p>
                <p style={{fontSize:'.8em', display:'none'}}><span style={{fontWeight:'bold'}}>Specialty:</span><br/>{card.label}</p> 
                <p style={{fontSize:'.8em'}}><span style={{fontWeight:'bold'}}>Ocean Advantage:</span> {card.ocean}</p> 
                <p style={{fontSize:'.8em'}}><span style={{fontWeight:'bold'}}>Hemi' Advantage:</span> {card.hemisphere}</p> 
                <div style={{fontSize:'.7em'}}><span style={{fontWeight:'bold'}}>Buffs:</span><div>{card.baseboost}</div><div>{card.legboost}</div><div>{card.skinboost}</div><div>{card.ttboost}</div><div>{card.oceanboost}</div><div>{card.hemiboost}</div><div>{card.tfboost}</div></div> 
        </div>
        </div>
            </div>
            
        </div>
    })}


</div></>
}

export {NFTGridCoachSelectable};